<lib-modal-header (close)="closeModal()">
  {{ "modals.doctor-rating.title" | translate }}
</lib-modal-header>
<lib-modal-body>
  <!-- Bar Rating -->
  <div class="container-rating">
    <bar-rating [(ngModel)]="doctorRating.rating" [max]="5" [theme]="'stars'" (rateChange)="onStarClick()">
    </bar-rating>
  </div>

  <!-- Text Review -->
  <lib-form-control>
    <label>
      <span libLabel>{{ "modals.doctor-rating.feedback" | translate }}</span>
      <lib-textarea
        placeholder="{{ 'modals.doctor-rating.optional' | translate }}"
        [(ngModel)]="doctorRating.review"
        maxlength="292"
      >
      </lib-textarea>
    </label>
  </lib-form-control>

  <!-- Anonymous Review Checkbox -->
  <lib-form-control>
    <lib-checkbox [(ngModel)]="doctorRating.is_anonymous" (change)="onAnonymousClick()">
      {{ "modals.doctor-rating.anonymous" | translate }}
    </lib-checkbox>
  </lib-form-control>
</lib-modal-body>

<lib-modal-footer>
  <div class="actions">
    <!-- Skip Review button -->
    <button libButton (click)="closeModal()" [appearance]="'grey-outline'">
      {{ "modals.confirm.actions.not-now" | translate }}
    </button>

    <!-- Submit Review button -->
    <button
      libButton
      (click)="submitRating()"
      [isPending]="false"
      [disabled]="doctorRating.rating < 1 || doctorRating.review.length > MAX_REVIEW_LENGTH || isLoading"
      className="submit-btn"
    >
      <p *ngIf="!isLoading">{{ "actions.submit" | translate }}</p>
      <p *ngIf="isLoading"><mat-spinner diameter="25" class="custom-spinner"></mat-spinner></p>
    </button>
  </div>
</lib-modal-footer>
